/* PS AFEX S7 — lazy drag-to-spin 3D air fryer (hero GLB via cookclub CDN) */
(function () {
  if (window.__PS_AFEX_S7_VIEWER__) return;
  window.__PS_AFEX_S7_VIEWER__ = true;

  var CFG = window.PS_AFEX_FINAL_3D || {};
  var HERO_GLB = CFG.heroGlb || 'https://api2.cookclub.ai/media/asset/8488b60c-1c7c-4f7f-8abf-bbc424015eca';

  function hasWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) {
      return false;
    }
  }

  function init() {
    var stage = document.getElementById('ps-afex-finalStage');
    var poster = document.getElementById('ps-afex-finalPoster');
    var canvasSlot = document.getElementById('ps-afex-finalCanvasSlot');
    var activateBtn = document.getElementById('ps-afex-finalActivate');
    if (!stage || !poster || !canvasSlot) return;

    if (!hasWebGL()) {
      stage.classList.add('no-webgl');
      if (activateBtn) activateBtn.hidden = true;
      return;
    }

    var activated = false;
    var loading = false;
    var renderer = null;
    var canvas = null;
    var scene = null;
    var camera = null;
    var model = null;
    var controls = null;
    var center = null;
    var fitDistance = 1.6;
    var inView = false;
    var dragging = false;
    var autoRotate = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var loopStarted = false;

    var threePromise = null;
    function getThree() {
      if (!threePromise) {
        threePromise = Promise.all([
          import('./af3d-ar-three.js'),
          import('./af3d-ar-gltfloader.js'),
          import('./af3d-ar-orbitcontrols.js'),
          import('./af3d-ar-meshopt-decoder.js')
        ]).then(function (mods) {
          return {
            THREE: mods[0],
            GLTFLoader: mods[1].GLTFLoader,
            OrbitControls: mods[2].OrbitControls,
            MeshoptDecoder: mods[3].MeshoptDecoder
          };
        });
      }
      return threePromise;
    }

    function resize(THREE) {
      if (!renderer || !camera) return;
      var w = Math.max(1, canvasSlot.clientWidth);
      var h = Math.max(1, canvasSlot.clientHeight);
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      if (model && center) {
        var fov = camera.fov * (Math.PI / 180);
        var dist = fitDistance / Math.tan(fov / 2);
        var offset = new THREE.Vector3(0.35, 0.12, 1).normalize().multiplyScalar(dist);
        camera.position.copy(center).add(offset);
        if (controls) {
          controls.target.copy(center);
          controls.update();
        }
      }
    }

    function startLoop() {
      if (loopStarted) return;
      loopStarted = true;
      function tick() {
        requestAnimationFrame(tick);
        if (!inView || !renderer || !scene || !camera) return;
        try {
          if (controls) controls.update();
          if (autoRotate && model && !dragging) {
            model.rotation.y += 0.004;
          }
          renderer.render(scene, camera);
        } catch (e) {
          console.error('[ps-afex-s7] render error', e);
        }
      }
      requestAnimationFrame(tick);
    }

    async function activate() {
      if (activated || loading) return;
      loading = true;
      stage.classList.add('is-loading');

      try {
        var mods = await getThree();
        var THREE = mods.THREE;

        canvas = document.createElement('canvas');
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.display = 'block';
        renderer = new THREE.WebGLRenderer({
          canvas: canvas,
          antialias: true,
          alpha: true,
          powerPreference: 'low-power'
        });
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
        renderer.outputColorSpace = THREE.SRGBColorSpace;
        renderer.toneMapping = THREE.ACESFilmicToneMapping;
        renderer.toneMappingExposure = 1.05;
        renderer.setClearColor(0x000000, 0);

        scene = new THREE.Scene();
        camera = new THREE.PerspectiveCamera(32, 1, 0.01, 100);

        var dir = new THREE.DirectionalLight(0xffffff, 1.65);
        dir.position.set(2.2, 3.4, 2.1);
        var hemi = new THREE.HemisphereLight(0xfff4e8, 0x1a1410, 0.55);
        scene.add(dir, hemi);

        canvasSlot.appendChild(canvas);
        resize(THREE);

        var loader = new mods.GLTFLoader();
        loader.setMeshoptDecoder(mods.MeshoptDecoder);
        loader.load(
          HERO_GLB,
          function (gltf) {
            model = gltf.scene;
            scene.add(model);

            var box = new THREE.Box3().setFromObject(model);
            var size = box.getSize(new THREE.Vector3());
            var c = box.getCenter(new THREE.Vector3());
            model.position.sub(c);
            center = new THREE.Vector3(0, 0, 0);
            fitDistance = Math.max(size.x, size.y, size.z) * 1.35;

            resize(THREE);

            controls = new mods.OrbitControls(camera, canvas);
            controls.target.set(0, 0, 0);
            controls.enableDamping = true;
            controls.dampingFactor = 0.08;
            controls.enablePan = false;
            controls.enableZoom = true;
            controls.minDistance = 0.8;
            controls.maxDistance = 2.4;
            controls.rotateSpeed = 0.9;
            controls.update();
            canvas.style.touchAction = 'none';

            controls.addEventListener('start', function () { dragging = true; });
            controls.addEventListener('end', function () { dragging = false; });

            poster.classList.add('is-hidden');
            if (activateBtn) activateBtn.classList.add('is-hidden');
            stage.classList.remove('is-loading');
            stage.classList.add('is-live');
            activated = true;
            loading = false;
            startLoop();
          },
          undefined,
          function (err) {
            console.error('[ps-afex-s7] GLB load failed', err);
            stage.classList.remove('is-loading');
            loading = false;
          }
        );
      } catch (err) {
        console.error('[ps-afex-s7] 3D init failed', err);
        stage.classList.remove('is-loading');
        loading = false;
      }
    }

    function onActivate() {
      activate();
    }

    stage.addEventListener('pointerdown', onActivate, { once: true });
    if (activateBtn) {
      activateBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        onActivate();
      }, { once: true });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        inView = entries.some(function (en) { return en.isIntersecting; });
      }, { threshold: 0.12 });
      io.observe(stage);
    } else {
      inView = true;
    }

    window.addEventListener('resize', function () {
      if (renderer) {
        getThree().then(function (mods) { resize(mods.THREE); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
